import { Component } from "@builder.io/sdk";

export const inquiryCiVrConfig: Component = {
  name: "Inquiry CI-VR",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "inquiry-ci-vr",
      friendlyName: "Section ID",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Need more details?",
      friendlyName: "Section Heading",
      helperText:
        "Main heading that encourages users to inquire about VR training programs",
      required: true,
    },
    {
      name: "subheading",
      type: "longText",
      defaultValue:
        "Contact us to learn more about our VR training technology and how it can benefit your organization.",
      friendlyName: "Subheading/Description",
      helperText:
        "Optional supporting text that provides more context about the inquiry form",
      advanced: false,
    },
    {
      name: "showImage",
      type: "boolean",
      defaultValue: true,
      friendlyName: "Show VR Image",
      helperText: "Whether to display the VR training image alongside the form",
      advanced: true,
    },
    {
      name: "formPosition",
      type: "string",
      defaultValue: "left",
      friendlyName: "Form Position",
      enum: ["left", "right"],
      helperText:
        "Position of the inquiry form: left (form on left, image on right) or right (form on right, image on left)",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "string",
      friendlyName: "Background Color",
      defaultValue: "white",
      enum: ["white", "primary-100", "secondary-100"],
      helperText:
        "Background color for the section: white, primary-100 (Light Primary), or secondary-100 (Light Secondary)",
      advanced: true,
    },
    {
      name: "formStyle",
      type: "string",
      friendlyName: "Form Style",
      defaultValue: "shadow",
      enum: ["shadow", "border", "minimal"],
      helperText:
        "Visual style of the form: shadow (with drop shadow), border (with border), or minimal (clean, no styling)",
      advanced: true,
    },
    {
      name: "textAlignment",
      type: "string",
      friendlyName: "Text Alignment",
      defaultValue: "left",
      enum: ["left", "center"],
      helperText: "Alignment of the heading and subheading text",
      advanced: true,
    },
  ],
};
